import * as GroupType from 'constants/GroupType';

const MARTIAL_ART_GROUP_MAP = {};

MARTIAL_ART_GROUP_MAP[0] = GroupType.DEFAULT_GROUP;
MARTIAL_ART_GROUP_MAP[1] = GroupType.FIRST_PERIOD_GROUP;
MARTIAL_ART_GROUP_MAP[2] = GroupType.SECOND_PERIOD_GROUP;
MARTIAL_ART_GROUP_MAP[3] = GroupType.THIRD_PERIOD_GROUP;
MARTIAL_ART_GROUP_MAP[4] = GroupType.FOURTH_PERIOD_GROUP;
MARTIAL_ART_GROUP_MAP[5] = GroupType.FIFTH_PERIOD_GROUP;

export default MARTIAL_ART_GROUP_MAP;



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/sportGlossary/MartialArt/GroupMap.js